import * as React from "react";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { useLocation } from "react-router";
import queryString from "query-string";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react-lite";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { SimpleSearcher } from "../../components/Searchers/SimpleSearcher/SimpleSearcher";
import { SearchTitle } from "../../components/SearchTitle/SearchTitle";
import { StudentsFilterQuerySerialized, getFiltersParamsSerialized } from "../../helpers/serializers/filters";
import { StudentsFilterQuery } from "../../api/typings/Filters";
import { SearchButton } from "../../components/Buttons/SearchButton/SearchButton";
import { tableStore } from "../../mobx/stores/TableStore/TableStore";
import { BaseTableSearcher } from "../../components/Searchers/BaseTableSearcher/BaseTableSearcher";
import { useStyles } from "./StudentsSearch.styles";
import { UserRoleEnum } from "../../static/enums/UserRole";

interface StudentsSearchProps {
  loading: boolean;
}

export const StudentsSearch = observer(({ loading }: StudentsSearchProps) => {
  const { getUsers } = tableStore;
  const methods = useForm();
  const { control, handleSubmit } = methods;
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const params = (queryString.parse(location.search) as unknown) as StudentsFilterQuerySerialized;

  return (
    <Grid item xs={12}>
      <Paper className={classes.root}>
        <SearchTitle />
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSearch)}>
            <BaseTableSearcher loading={loading} />
            <Grid container spacing={2} justify={"flex-start"} alignContent={"center"}>
              <Grid item lg={3} md={3} sm={6} xs={12}>
                <SimpleSearcher
                  name={"profiles-student-payment_comment"}
                  label={"Комментарий"}
                  loading={loading}
                  defaultValue={params["filter[profiles][student][payment_comment]"]}
                />
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={12}>
                <Controller
                  name={"profiles-student-is_studying"}
                  control={control}
                  defaultValue={params["filter[profiles][student][is_studying]"] || "1"}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <FormControl variant="outlined" size={"small"} className={classes.formControl}>
                        <Select value={value} displayEmpty onChange={onChange} autoWidth>
                          <MenuItem value={""}>Не выбрано</MenuItem>
                          <MenuItem value={1}>Да</MenuItem>
                          <MenuItem value={0}>Нет</MenuItem>
                        </Select>
                        <FormHelperText>В процессе обучения</FormHelperText>
                      </FormControl>
                    );
                  }}
                />
              </Grid>
            </Grid>
            <SearchButton loading={loading} />
          </form>
        </FormProvider>
      </Paper>
    </Grid>
  );

  function onSearch(data: StudentsFilterQuery) {
    const dataSerialized = getFiltersParamsSerialized<StudentsFilterQuery, StudentsFilterQuerySerialized>(data);
    const searchString = queryString.stringify(dataSerialized);
    history.push({
      search: searchString,
    });
    getUsers({
      ...dataSerialized,
      "filter[role]": UserRoleEnum.student,
    });
  }
});
